import React, { useEffect, useState } from 'react';
import ListClientsTable from './ListClientsTable';
import columnsTable from './ListClientsTableColumns';
import { UserAuthContext } from '../context/AuthContext';

const UserList = ({ currentYearAdmin }) => {
  const { getUserList } = UserAuthContext();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const getUsers = async () => {
      const data = await getUserList({ currentYearAdmin });
      setUsers(
        data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          enrolmentYear: currentYearAdmin,
        })),
      );
    };
    getUsers();
  }, [currentYearAdmin, getUserList]);

  return (
    <>
      <div className="flex flex-col bg-blue-50 justify-center">
        {users && (
          <ListClientsTable usersData={users} columnsTable={columnsTable} />
        )}
      </div>
    </>
  );
};

export default UserList;
